<template>
<div id="apptable" v-cloak>

    <b-card :header="header" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <!-- :header="'Prenotazioni evento #' + id" -->
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <label for="datainizio">Data inizio:</label>
                    <b-form-input v-model="datainizio" id="datainizio" type="date" />
                </div>
                <div class="col-md-3">
                    <label for="datafine">Data fine:</label>
                    <b-form-input v-model="datafine" id="datafine" type="date" />
                </div>
            </div>

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-2">    
                    <b-form-select v-show="this.id == null" v-model="tipo" :options="options_tipo" id="tipo">
                           
                    </b-form-select>
                </div>
                <div class="col-md-7 text-right">
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-secondary" @click.stop="exportCSV()">
                        Esporta CSV
                    </b-button>
                    <b-button v-show="this.id != null" style="margin:1px 0px 1px 2px;" size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable && showtable2" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                
                <!-- EVENTI OPPURE IMPIANTI SENZA PERSONALIZZAZIONE -->
                <template v-if="!showflgpreimplistpers1" slot="id" scope="row">{{row.value}}</template>
                <template v-if="!showflgpreimplistpers1" slot="note" scope="row">{{row.value | formatNote}}</template>
                <template v-if="!showflgpreimplistpers1" slot="datainizio" scope="row">{{row.value | formatDate}}</template>
                <template v-if="!showflgpreimplistpers1" slot="datafine" scope="row">{{row.value | formatDate}}</template>
                <template v-if="!showflgpreimplistpers1" slot="orainizio" scope="row">{{row.value}}</template>
                <template v-if="!showflgpreimplistpers1" slot="orafine" scope="row">{{row.value}}</template>  
                <template v-if="!showflgpreimplistpers1" slot="datains" scope="row">{{row.value | formatDateTime}}</template>                      
                <template v-if="!showflgpreimplistpers1" slot="stato" scope="row">{{row.value}}</template>
                <template v-if="!showflgpreimplistpers1" slot="socioVis" scope="row">{{row.value}}</template>

                <template slot="totacconto" scope="row" v-if="this.$route.params.tipo == 'E'">
                    <div :style="getImportoStyle(row.value)">
                        {{row.value}}
                    </div>
                </template>
                <template slot="totsaldo" scope="row" v-if="this.$route.params.tipo == 'E'">
                    <div :style="getImportoStyle(row.value)">
                        {{row.value}}
                    </div>
                </template>

                <!--IMPIANTI CON PERSONALIZZAZIONE DA DASHBOARD-->
                <template v-if="showflgpreimplistpers1" slot="id" scope="row">{{row.value}}</template>
                <template v-if="showflgpreimplistpers1" slot="nominativoimpianto" scope="row">{{row.value}}</template>
                <template v-if="showflgpreimplistpers1" slot="dataVis" scope="row">{{row.value}}</template>
                <template v-if="showflgpreimplistpers1" slot="oraVis" scope="row">{{row.value}}</template>
                <template v-if="showflgpreimplistpers1" slot="socioVis" scope="row">{{row.value}}</template>
                <template v-if="showflgpreimplistpers1" slot="ssosocio" scope="row">{{row.value}}</template>                     
                <template v-if="showflgpreimplistpers1" slot="stato" scope="row">{{row.value}}</template>
                <template v-if="showflgpreimplistpers1" slot="socio2Vis" scope="row">{{row.value}}</template>
                <template v-if="showflgpreimplistpers1" slot="importoVis" scope="row">
                    <div :style="getImportoImpiantiStyle(row.item)">
                        {{row.value}}
                    </div>    
                </template>
                
                <template slot="modifica" scope="row">
                    <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                    <b-btn v-if="!showflgpreimplistpers1" style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                    <b-btn v-if="showflgpreimplistpers1 && row.item.flagsta != 'A' && row.item.flagsta != 'P'" style="margin:0px 0px 1px 2px;" size="sm" @click.stop="paga(row.item,row.index,$event.target)">Paga</b-btn>
                    <b-btn v-if="showflgpreimplistpers1" style="margin:0px 0px 1px 2px;" size="sm" @click.stop="noteabbonamento(row.item,row.index,$event.target)">Note abbonamento</b-btn>
                </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione della prenotazione #{{deleteModal.id}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

    <!-- Modal Component -->
    <b-modal v-model="pagaModal.show" title="Paga">
        <p class="my-2">Confermi il pagamento della prenotazione #{{pagaModal.id}} del socio {{pagaModal.socioVis}}?</p>
        <b-row class="my-1">
            <b-col sm="6">                                    
                <b-input-group prepend="Saldo totale €">
                    <b-form-input v-model="pagaModal.totalesaldo" id="totalesaldo" type="text"></b-form-input>
                </b-input-group>
            </b-col>
        </b-row>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="pagaItem(pagaModal.item, pagaModal.totalesaldo)" style="margin: 2px;">
                Conferma pagamento
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="pagaModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

    <!-- Modal Component -->
    <b-modal v-model="noteabbonamentoModal.show" title="Note abbonamento">
        <p class="my-2">Note abbonamento #{{noteabbonamentoModal.id}} del socio {{noteabbonamentoModal.socioVis}}?</p>
        <b-row class="my-1">
            <b-col sm="12"> 
                <b-input-group prepend="Note">
                    <b-form-textarea id="note" v-model="noteabbonamentoModal.note" :rows="5"></b-form-textarea>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row class="my-1">
            <b-col sm="12">                
                    <b-btn variant="warning" size="sm" @click.stop="noteabbonamentoAmmonizione()">Autocompletamento ammonizione</b-btn>
            </b-col>
        </b-row>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="noteabbonamentoItem(noteabbonamentoModal.id, noteabbonamentoModal.note)" style="margin: 2px;">
                Salva
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="noteabbonamentoModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

    <!-- Modal Component Date -->
    <b-modal v-model="dateModal.show" title="Seleziona la data e il socio per la prenotazione">
        <div class="col-md-12">
            <label for="selDate">Data:</label>
            <b-form-input v-model="dateModal.selDate" id="selDate" type="date"></b-form-input> 
            <b-alert style="margin-top:10px;" :show="(dateModal.errorData != '')" variant="danger">{{ dateModal.errorData }}</b-alert>           
        </div>
        <br> 
        <div class="col-md-12">
            <label for="socio">Socio:</label>
            <b-input-group>
                <b-form-input v-model="dateModal.dateSocioVis" id="socio" type="text" disabled></b-form-input>
                <b-input-group-append>
                    <!-- <b-btn v-show="socioVis !== ''" variant="secondary" @click="delSocio()">Elimina</b-btn> -->
                    <b-btn variant="primary" @click="selSocio()">Seleziona</b-btn>
                </b-input-group-append>
            </b-input-group>
        </div>  
        <br v-if="flgsocio2 == 'S'"> 
        <div class="col-md-12" v-if="flgsocio2 == 'S'">
            <label for="socio2">Secondo socio partecipante:</label>
            <b-input-group>
                <b-form-input v-model="dateModal.dateSocioVis2" id="socio2" type="text" disabled></b-form-input>
                <b-input-group-append>
                    <b-btn v-show="dateModal.dateSocioVis2 !== ''" variant="secondary" @click="delSocio2()">Elimina</b-btn>
                    <b-btn variant="primary" @click="selSocio2()">Seleziona</b-btn>
                </b-input-group-append>
            </b-input-group>
        </div>  
        <br>
        <div class="col-md-12">
            <label for="selDisp">Disponibilità:</label>
            <b-table responsive small id="main-table" striped hover show-empty :items="dateModal.items" :fields="dateModal.fields" :current-page="dateModal.currentPage" :per-page="dateModal.perPage">
                <template slot="orario" scope="row"><b>{{row.value}}</b></template>
                <template slot="descrizione" scope="row">{{row.value}}</template>
                <template slot="seleziona" scope="row">
                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-btn v-show="row.item.tipo == 'L' || row.item.tipo == 'R'" size="sm" variant="primary" @click.stop="prenota(row.item,row.index,$event.target)">Prenota</b-btn>
                    <b-btn v-show="row.item.tipo == 'M' || row.item.tipo == 'W'" size="sm" variant="danger" @click.stop="annullapreno(row.item,row.index,$event.target)">Annulla</b-btn>
                </template>
            </b-table>      
        </div>
        
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="secondary" @click.stop="chiudiModalDate()" style="margin: 2px;">
                Chiudi
            </b-btn>
        </div>
    </b-modal>

    <!-- Modal Component -->
    <b-modal size="lg" v-model="sociModal.show" title="Seleziona il socio">
        <div class="text-left">
            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="sociModal.filter" placeholder="Cerca..." />
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive small id="main-table" striped hover show-empty :items="sociModal.items" :fields="sociModal.fields" :current-page="sociModal.currentPage" :per-page="sociModal.perPage" :filter="sociModal.filter" :sort-by.sync="sociModal.sortBy" :sort-desc.sync="sociModal.sortDesc"
                @filtered="onFiltered">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="cognome" scope="row">{{row.value}}</template>
                <template slot="nome" scope="row">{{row.value}}</template>
                <!-- <template slot="matricola" scope="row">{{row.value}}</template> -->
                <template slot="email" scope="row">{{row.value}}</template>
                <template slot="seleziona" scope="row">
                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-btn size="sm" variant="danger" @click.stop="seleziona(row.item,row.index,$event.target)">Seleziona</b-btn>
            </template>
            </b-table>


            <div class="row my-1">
                <div class="col-md-7 col-sm-12">
                    <b-pagination :total-rows="totalRowsSoci" :per-page="sociModal.perPage" v-model="sociModal.currentPage" />
                </div>
                <div class="col-md-5 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="sociModal.pageOptions" v-model="sociModal.perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>


        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="secondary" @click="sociModal.show=false" style="margin: 2px;">
                Chiudi
            </b-btn>
        </div>
    </b-modal>   

    <!-- Modal Component -->
    <b-modal size="lg" v-model="sociModal2.show" title="Seleziona il secondo socio partecipante">
        <div class="text-left">
            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="sociModal2.filter" placeholder="Cerca..." />
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive small id="main-table" striped hover show-empty :items="sociModal2.items" :fields="sociModal2.fields" :current-page="sociModal2.currentPage" :per-page="sociModal2.perPage" :filter="sociModal2.filter" :sort-by.sync="sociModal2.sortBy" :sort-desc.sync="sociModal2.sortDesc"
                @filtered="onFiltered">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="cognome" scope="row">{{row.value}}</template>
                <template slot="nome" scope="row">{{row.value}}</template>
                <!-- <template slot="matricola" scope="row">{{row.value}}</template> -->
                <template slot="email" scope="row">{{row.value}}</template>
                <template slot="seleziona" scope="row">
                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-btn size="sm" variant="danger" @click.stop="seleziona2(row.item,row.index,$event.target)">Seleziona</b-btn>
            </template>
            </b-table>


            <div class="row my-1">
                <div class="col-md-7 col-sm-12">
                    <b-pagination :total-rows="totalRowsSoci2" :per-page="sociModal2.perPage" v-model="sociModal2.currentPage" />
                </div>
                <div class="col-md-5 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="sociModal2.pageOptions" v-model="sociModal2.perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>


        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="secondary" @click="sociModal2.show=false" style="margin: 2px;">
                Chiudi
            </b-btn>
        </div>
    </b-modal>  
    
</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    Prenotazione,
    Categoria,
    Socio
} from '../classes.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {      
            id: this.$route.params.id || null,  
            tipo: this.$route.params.tipo || 'I', 
            flgsocio2: 'N', 
            msgpreno: '',
            nominativo: '',
            items: [],
            namespace: NAMESPACE,
            fields: {
               //spostato tutto all'inizio del created
            },
            deleteModal: {
                id: null,
                show: false
            },    
            noteabbonamentoModal: {
                id: null,
                show: false,
                note: '',
                item: null,
                socioVis: '',
            },        
            pagaModal: {
                id: null,
                show: false,
                nominativoimpianto: '',
                dataVis: '',
                oraVis: '',
                socioVis: '',
                item: null,
            },
            dateModal: {
                show: false,
                id: null,
                selDate: moment().format("YYYY-MM-DD"),
                errorData: '',

                id_socio: null,
                nomesocio: '',
                cognomesocio: '',
                accountsocio: '',
                dateSocioVis: '',   
                
                id_socio2: null,
                nomesocio2: '',
                cognomesocio2: '',
                accountsocio2: '',
                dateSocioVis2: '',
                
                currentPage: 1,
                perPage: 50,
                items: [],
                fields: {
                    orario: {
                        label: 'Orario',
                        sortable: false
                    },
                    descrizione: {
                        label: ' ',
                        sortable: false
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,           
            error: '',
            showerror: false,
            showtable: false,  
            showtable2: false,            
            datainizio: this.$route.params.datainizio || null,
            datafine: this.$route.params.datafine || null,            
            parametri: null,
            showflgpreimplistpers1: false,
            options_tipo:[{
                text: 'Impianti',
                value: 'I'
            }, {
                text: 'Eventi',
                value: 'E'    
            }],
            sociModal: {
                show: false,
                items: [],
                fields: {
                    id: {
                        label: '#',
                        sortable: true
                    },
                    cognome: {
                        label: 'Cognome',
                        sortable: true
                    },
                    nome: {
                        label: 'Nome',
                        sortable: true
                    },
                    email: {
                        label: 'Email',
                        sortable: true
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
                currentPage: 1,
                perPage: 5,
                pageOptions: [{
                    text: 5,
                    value: 5
                }, {
                    text: 10,
                    value: 10
                }, {
                    text: 15,
                    value: 15
                }],
                sortBy: null,
                sortDesc: false,
                filter: null,                
                totalRowsFilter: null,
            },
            sociModal2: {
                show: false,
                items: [],
                fields: {
                    id: {
                        label: '#',
                        sortable: true
                    },
                    cognome: {
                        label: 'Cognome',
                        sortable: true
                    },
                    nome: {
                        label: 'Nome',
                        sortable: true
                    },
                    email: {
                        label: 'Email',
                        sortable: true
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
                currentPage: 1,
                perPage: 5,
                pageOptions: [{
                    text: 5,
                    value: 5
                }, {
                    text: 10,
                    value: 10
                }, {
                    text: 15,
                    value: 15
                }],
                sortBy: null,
                sortDesc: false,
                filter: null,                
                totalRowsFilter: null,
            }           
        };
    },    
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY')
        }
    },
    computed: {        
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        },
        totalRowsSoci: {
            // getter
            get: function () {
                return this.sociModal.totalRowsFilter || this.sociModal.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.sociModal.totalRowsFilter = newValue;
            }
        },
        totalRowsSoci2: {
            // getter
            get: function () {
                return this.sociModal2.totalRowsFilter || this.sociModal2.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.sociModal2.totalRowsFilter = newValue;
            }
        },
        header: {
            // getter
            get: function () {
                var aux = "Prenotazioni";

                if(this.id == null){
                    aux += (this.tipo == 'E' ? ' eventi' : (this.tipo == 'I' ? ' impianti' : ''))
                }
                else{
                    aux += (this.tipo == 'E' ? ' evento #' + this.id : (this.tipo == 'I' ? ' impianto #' + this.id + " - " + this.nominativo : ' #' + this.id))
                }               

                return aux;
            },
            // setter
            set: function (newValue) {

            }
        },
    },
    watch: {
        'dateModal.selDate': function(val, oldVal) {
            if(val < moment().format("YYYY-MM-DD")){ //se data più vecchia di oggi
                alert("Non è possibile selezionare una data minore di oggi!")
                this.dateModal.selDate = moment().format("YYYY-MM-DD");
            }
            else{
                this.caricaOrariPreno();  
            }          
        },
        'dateModal.id_socio': function(val, oldVal) {
            this.caricaOrariPreno();            
        },
        datainizio: function (newValue, oldValue) {  
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)  
            this.datafine = (this.datafine == '' ? null : this.datafine)  
            if(this.id == null){
                this.$router.replace({
                    path: `/app/prenotazioni/tipo/${this.tipo}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/prenotazioni/id/${this.id}/tipo/${this.tipo}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }  
            this.loadData();     
        },
        datafine: function (newValue, oldValue) {  
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)  
            this.datafine = (this.datafine == '' ? null : this.datafine) 
            if(this.id == null){
                this.$router.replace({
                    path: `/app/prenotazioni/tipo/${this.tipo}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/prenotazioni/id/${this.id}/tipo/${this.tipo}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }   
            this.loadData();
        },
        tipo: function (newValue, oldValue) {  
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)  
            this.datafine = (this.datafine == '' ? null : this.datafine) 

            if(this.id == null){
                this.$router.replace({
                    path: `/app/prenotazioni/tipo/${this.tipo}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/prenotazioni/id/${this.id}/tipo/${this.tipo}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }    
            this.showtable = false;
            this.loadParametriData();
        },
    },
    methods: {
        caricaOrariPreno(){

            if(this.dateModal.selDate != '' && this.dateModal.id_socio != null){

                this.dateModal.errorData = '';
                this.dateModal.items = [];

                var token = localStorage.getItem('token');
                this.axios.get(NAMESPACE + 'rest/calendarioora/id_scheda/' + this.id + '/tipo/' + this.tipo + '/data/' + this.dateModal.selDate + '/id_socio/' + this.dateModal.id_socio, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var auxitems = response.data.message; 

                            //console.log("AAAAA: " + JSON.stringify(auxitems));
                            
                            var nonchiuso = false;
                            auxitems.forEach(function(element, index) {
                                if(element.tipo != "C"){
                                    nonchiuso = true;
                                }                                               
                            });
                            if(nonchiuso){
                                while(auxitems[0].tipo == "C"){
                                    auxitems.shift();
                                }
                                while(auxitems[auxitems.length - 1].tipo == "C"){
                                    auxitems.pop();
                                }
                            }
                            
                            auxitems.forEach(function(element, index) {

                                element.orario = element.orainizio;

                                if (element.tipo == 'C') {
                                    if((element.descrizioneorario || '') != ''){
                                        element.descrizione = element.descrizioneorario;
                                    }
                                    else{
                                        element.descrizione = 'Chiuso';
                                    }                                    
                                    element._rowVariant = 'secondary';
                                }
                                else if (element.tipo == 'P') {
                                    element.descrizione = 'Prenotato';
                                    element._rowVariant = 'danger';
                                }
                                else if (element.tipo == 'M' || element.tipo == 'W') {
                                    element.descrizione = 'Prenotato da utente stesso' + (element.tipo == 'W' ? " RISERVA" : "");
                                    element.nomesocio2 = element.nomesocio2 || '';
                                    element.cognomesocio2 = element.cognomesocio2 || '';
                                    element.accountsocio2 = element.accountsocio2 || '';
                                    if(element.nomesocio2 != '' || element.cognomesocio2 != '' || element.accountsocio2 != ''){
                                        element.descrizione += ' con ' + element.nomesocio2 + ' ' + element.cognomesocio2 + ' - ' + element.accountsocio2;
                                    }
                                    element._rowVariant = 'info';                                
                                }
                                else if (element.tipo == 'N') {
                                    if((element.descrizioneorario || '') != ''){
                                        element.descrizione = element.descrizioneorario;
                                    }
                                    else{
                                        element.descrizione = 'Non prenotabile';
                                    } 
                                    element._rowVariant = 'warning';
                                }  
                                else if (element.tipo == 'L') {
                                    element.descrizione = 'Libero';
                                    element._rowVariant = 'success';
                                }    
                                else if (element.tipo == 'R') {
                                    element.descrizione = 'Riserva (OVERBOOKING)';
                                    element._rowVariant = 'info';
                                }             
                            });

                            //alert("Res: " + JSON.stringify(auxitems));

                            this.dateModal.items = auxitems;

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {
                        //this.showerror = true;
                        this.dateModal.errorData = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    //this.showerror = true;
                    this.dateModal.errorData = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

            }

        },
        chiudiModalDate(){
            //this.loadData();
            this.dateModal.show = false;
        },
        noteabbonamento(item, index, button) {

            let today = moment(String(new Date())).format('YYYY-MM-DD');

            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + `rest/abbonamenti/id_socio/${item.id_socio}/flagatt/S/date/${today}/datafinebloccopreno/S`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        //this.noteabbonamentoModal.items = response.data.message;
                        let res = response.data.message;
                        if(res.length > 0){
                            
                            //si prende sempre il primo anche se non è proprio il massimo
                            //il primo dovrebbe essere quello con datafine maggiore valido
                            this.noteabbonamentoModal.id = res[0].id;
                            this.noteabbonamentoModal.note = res[0].note;                            

                            this.noteabbonamentoModal.item = item;
                            this.noteabbonamentoModal.socioVis = item.socioVis;                     

                            this.noteabbonamentoModal.show = true;
                        }
                        else{
                            alert("Attenzione, nessun abbonamento valido trovato!");
                        }

                    } else {
                        throw new Error(response.data.message);
                    }


                } catch (e) {
                    alert("Errore: " + e.message);
                }

            })
            .catch(e => {
                alert("Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
            });
            
        },
        prenota(item, index, button) {

                var msgprenoAux = (this.msgpreno || '').trim();
                var flgacpmsgprenoAux = "N";
                //accettazione condizioni, modifica pensata per il covid
                if(msgprenoAux != ''){
                    if(!confirm(msgprenoAux)){
                        return;
                    }
                    else{
                        flgacpmsgprenoAux = "S";
                    }
                }        
                
                var msgAuxR = "";
                if(item.tipo == 'R'){
                    msgAuxR = "in modalità riserva (OVERBOOKING) ";
                }

                var res = confirm("Confermi di voler prenotare l'impianto " + msgAuxR + "per il " + this.$options.filters.formatDate(this.dateModal.selDate) + " alle " + item.orario + "?");
     
                if(res){

                    var prenotazione = {
                        flagsta: (item.tipo == 'R' ? 'R' : 'I'), //riserva o inserito
                        tipo: this.tipo,
                        orainizio: item.orainizio,
                        orafine: item.orafine,
                        datainizio: this.dateModal.selDate,
                        datafine: this.dateModal.selDate,
                        id_scheda: this.id,
                        id_socio: this.dateModal.id_socio,
                        msgpreno: msgprenoAux,
                        flgacpmsgpreno: flgacpmsgprenoAux,
                    };

                    if(this.flgsocio2 == 'S' && this.dateModal.accountsocio2 != ''){
                        prenotazione.accountsocio2 = this.dateModal.accountsocio2;
                    }

                    var json = JSON.stringify(prenotazione);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/prenotazionecalendario', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message; //mi ritorna la prenotazione  

                                    this.loadData();
                                    this.caricaOrariPreno(); 

                                    if(res.flagsta == prenotazione.flagsta && res.flagsta == "I"){
                                        alert("Prenotazione inserita con successo!");
                                    }
                                    else if(res.flagsta == prenotazione.flagsta && res.flagsta == "R"){
                                        alert("Prenotazione inserita in modalità riserva (OVERBOOKING) inserita con successo!");
                                    }
                                    else if(res.flagsta != prenotazione.flagsta && res.flagsta == "I"){//casi particolari rarissimi
                                        alert("Attenzione, prenotazione inserita con successo, si è liberato un posto diversamente da quanto previsto!");
                                    }
                                    else if(res.flagsta != prenotazione.flagsta && res.flagsta == "R"){//casi particolari rarissimi
                                        alert("Attenzione, prenotazione inserita in modalità riserva (OVERBOOKING) diversamente da quanto previsto!");
                                    }                                    
                                    
                                    //alert("Prenotazione inserita con successo!");

                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                alert("Errore: " + e.message);
                            }

                        })
                        .catch(e => {
                            alert("Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                        });

                }

        },
        annullapreno(item, index, button) { 

            //console.log("AAAA: " + JSON.stringify(item))

            var msgAuxW = "";
            if(item.tipo == "W"){
                msgAuxW = "in modalità riserva (OVERBOOKING) ";
            }

            var res = confirm("Confermi di voler annullare la prenotazione " + msgAuxW + "dell'impianto per il " + this.$options.filters.formatDate(this.dateModal.selDate) + " alle " + item.orario + "?");
     
                if(res){

                    var prenotazione = {
                        flagsta: 'A',
                        tipo: this.tipo,
                        id: item.id_prenotazione,
                        id_scheda: this.id,
                        id_socio: this.dateModal.id_socio,
                    };

                    var json = JSON.stringify(prenotazione);

                    //alert(json);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/prenotazionecalendario', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;                               

                                    this.loadData();
                                    this.caricaOrariPreno();
                                        
                                    alert("Annullamento prenotazione eseguito con successo!");                                

                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                alert("Errore: " + e.message);
                            }

                        })
                        .catch(e => {
                            alert("Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                        });

                }

        },
        seleziona(item, index, button) {    
            
            this.dateModal.id_socio = item.id;
            this.dateModal.nomesocio = item.nome;
            this.dateModal.cognomesocio = item.cognome;
            this.dateModal.accountsocio = item.email;
            this.dateModal.dateSocioVis = this.dateModal.cognomesocio + " " + this.dateModal.nomesocio + " - " + this.dateModal.accountsocio;
            this.sociModal.show = false;

        }, 
        seleziona2(item, index, button) {    
            
            this.dateModal.id_socio2 = item.id;
            this.dateModal.nomesocio2 = item.nome;
            this.dateModal.cognomesocio2 = item.cognome;
            this.dateModal.accountsocio2 = item.email;
            this.dateModal.dateSocioVis2 = this.dateModal.cognomesocio2 + " " + this.dateModal.nomesocio2 + " - " + this.dateModal.accountsocio2;
            this.sociModal2.show = false;

            //console.log("AAAAA: " + this.dateModal.dateSocioVis2);

        }, 
        /*
        selDate(item, index, button) {    
            
            if (this.dateModal.selDate == "") {
                this.dateModal.errorData = "Campo data prenotazione vuoto!";
            }
            else if (this.dateModal.selDate < moment().format("YYYY-MM-DD")){
                this.dateModal.errorData = "Data prenotazione minore della data odierna!";
            }
            else if (this.dateModal.id_socio == '' || this.dateModal.id_socio == null){
                this.dateModal.errorData = "Selezionare il socio!";
            }
            else{     
                this.$router.push('/app/calendarioimpianto/id_scheda/' + this.id + '/tipo/' + this.tipo + '/data/' + this.dateModal.selDate + '/id_socio/' + this.dateModal.id_socio);
            }

        },*/
        selSocio() {

            var token = localStorage.getItem('token');
            //this.axios.get(NAMESPACE + 'rest/soci', {
                this.axios.get(NAMESPACE + 'rest/soci/flgatt/S', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.sociModal.items = response.data.message;
                            this.sociModal.items.forEach(function(element, index) {
                                delete element.uteins; //per motivi di ricerca
                            });
                            this.sociModal.show = true;

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.sociModal.showerror = true;
                    this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }, 
        delSocio2() {
            
            this.dateSocioVis2 = '';
            this.dateModal.id_socio2 = null;
            this.dateModal.nomesocio2 = '';
            this.dateModal.cognomesocio2 = '';
            this.dateModal.accountsocio2 = '';
            this.dateModal.dateSocioVis2 = '';

        },
        selSocio2() {

            var token = localStorage.getItem('token');
            //this.axios.get(NAMESPACE + 'rest/soci', {
                this.axios.get(NAMESPACE + 'rest/soci/flgatt/S', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.sociModal2.items = response.data.message;
                            this.sociModal2.items.forEach(function(element, index) {
                                delete element.uteins; //per motivi di ricerca
                            });
                            this.sociModal2.show = true;

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.sociModal2.showerror = true;
                        this.sociModal2.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.sociModal2.showerror = true;
                    this.sociModal2.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },     
        exportCSV() {

            if (this.items.length > 0) {
                var str = '';

                if(!this.showflgpreimplistpers1){
                    if (this.tipo == 'E'){
                        str = '"#";"Note";"Data inizio";"Data fine";"Ora inizio";"Ora fine";"Data inserimento";"Stato";"Socio";"Acconto riscosso/totale €";"Saldo riscosso/totale €"\r\n';
                    }
                    else{
                        str = '"#";"Note";"Data inizio";"Data fine";"Ora inizio";"Ora fine";"Data inserimento";"Stato";"Socio"\r\n';
                    }
                    //var str = '"#";"Note";"Data inizio";"Data fine";"Ora inizio";"Ora fine";"Data inserimento";"Stato";"Socio";"Acconto riscosso/totale €";"Saldo riscosso/totale €"\r\n';
                    for (var i = 0; i < this.items.length; i++) {
                        str += '"' + this.items[i].id + '"' + ";";
                        str += '"' + (this.items[i].note || '').replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + this.items[i].datainizio + '"' + ";";
                        str += '"' + this.items[i].datafine + '"' + ";";
                        str += '"' + this.items[i].orainizio + '"' + ";";
                        str += '"' + this.items[i].orafine + '"' + ";";
                        str += '"' + this.items[i].datains + '"' + ";";                    
                        str += '"' + (this.items[i].stato || '').replace(/\"/g, "\"\"") + '"' + ";";
                        if (this.tipo == 'E'){
                            str += '"' + (this.items[i].socioVis || '').replace(/\"/g, "\"\"") + '"' + ";";
                            str += '"' + this.items[i].totacconto + '"' + ";";
                            str += '"' + this.items[i].totsaldo + '"' + "\r\n";
                        }
                        else{
                            str += '"' + (this.items[i].socioVis || '').replace(/\"/g, "\"\"") + '"' + "\r\n";
                        }
                    }
                }
                else{
                    //impianti da dashboard
                    str = '"#";"Impianto";"Data";"Orario";"Socio";"SSO";"Stato";"Secondo socio";"Importo €"\r\n';

                    for (var i = 0; i < this.items.length; i++) {
                        str += '"' + this.items[i].id + '"' + ";";                        
                        str += '"' + (this.items[i].nominativoimpianto || '').replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + (this.items[i].dataVis || '').replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + (this.items[i].oraVis || '').replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + (this.items[i].socioVis || '').replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + (this.items[i].ssosocio || '').replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + (this.items[i].stato || '').replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + (this.items[i].socio2Vis || '').replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + (this.items[i].importoVis || '').replace(/\"/g, "\"\"") + '"' + "\r\n";                       
                    }
                }



                var a = document.createElement('a');
                var blob = new Blob([str], {
                    'type': 'application\/octet-stream'
                });

                a.href = window.URL.createObjectURL(blob);
                let auxNome = (this.id == null ? '' : this.id + '_' ) + (this.tipo == 'E' ? 'eventi' : (this.tipo == 'I' ? 'impianti' : '')) + '_'
                a.download = 'prenotazioni_' + auxNome + moment(String(new Date())).format('YYYYMMDD_HHmmss') + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function() {
                    document.body.removeChild(a);
                }, 100);

            }

        }, 
        loadParametriData(){
            
            if(this.tipo == 'E'){
                this.fields = {
                        id: {
                            label: '#',
                            sortable: true
                        },
                        note: {
                            label: 'Note',
                            sortable: true
                        },
                        datainizio: {
                            label: 'Data inizio',
                            sortable: true
                        },
                        datafine: {
                            label: 'Data fine',
                            sortable: true
                        },
                        orainizio: {
                            label: 'Ora inizio',
                            sortable: true
                        },
                        orafine: {
                            label: 'Ora fine',
                            sortable: true
                        },
                        datains: {
                            label: 'Data inserimento',
                            sortable: true
                        },
                        stato: {
                            label: 'Stato',
                            sortable: true
                        },
                        socioVis: {
                            label: 'Socio',
                            sortable: true
                        },
                        totacconto: {
                            label: 'Acconto riscosso/totale €',
                            sortable: true
                        },
                        totsaldo: {
                            label: 'Saldo riscosso/totale €',
                            sortable: true
                        },
                        modifica: {
                            label: ' ',
                            'class': 'text-right'
                        }
                    };
            }
            else{
                this.fields = {
                        id: {
                            label: '#',
                            sortable: true
                        },
                        note: {
                            label: 'Note',
                            sortable: true
                        },
                        datainizio: {
                            label: 'Data inizio',
                            sortable: true
                        },
                        datafine: {
                            label: 'Data fine',
                            sortable: true
                        },
                        orainizio: {
                            label: 'Ora inizio',
                            sortable: true
                        },
                        orafine: {
                            label: 'Ora fine',
                            sortable: true
                        },
                        datains: {
                            label: 'Data inserimento',
                            sortable: true
                        },
                        stato: {
                            label: 'Stato',
                            sortable: true
                        },
                        socioVis: {
                            label: 'Socio',
                            sortable: true
                        },
                        modifica: {
                            label: ' ',
                            'class': 'text-right'
                        }
                    };
            }

            var token = localStorage.getItem('token');

            //PAREMETRI
            this.axios.get(NAMESPACE + 'rest/cral', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            //alert("Ret: " + JSON.stringify(res))
                            if (typeof res == "object") {

                                this.parametri = res;

                                if(this.parametri.flgpreimplistpers1 == 'S' && this.id == null && this.tipo == 'I'){

                                    this.showflgpreimplistpers1 = true;

                                    this.fields = {
                                                        id: {
                                                            label: '#',
                                                            sortable: true
                                                        },
                                                        nominativoimpianto: {
                                                            label: 'Impianto',
                                                            sortable: true
                                                        },
                                                        dataVis: {
                                                            label: 'Data',
                                                            sortable: true
                                                        },
                                                        oraVis: {
                                                            label: 'Orario',
                                                            sortable: true
                                                        },
                                                        socioVis: {
                                                            label: 'Socio',
                                                            sortable: true
                                                        },
                                                        ssosocio: {
                                                            label: 'SSO',
                                                            sortable: true
                                                        },
                                                        stato: {
                                                            label: 'Stato',
                                                            sortable: true
                                                        },
                                                        socio2Vis: {
                                                            label: 'Secondo socio',
                                                            sortable: true
                                                        },
                                                        importoVis: {
                                                            label: 'Importo €',
                                                            sortable: true
                                                        },
                                                        modifica: {
                                                            label: ' ',
                                                            'class': 'text-right'
                                                        }
                                                    };
                                }
                                else{                                    
                                    this.showflgpreimplistpers1 = false;
                                }

                                this.loadData();  

                            } else {
                                throw new Error("Errore parametri non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        loadData() {

            var token = localStorage.getItem('token');            
            this.axios.get(NAMESPACE + 'rest/prenotazioni/id_scheda/' + this.id + '/tipo/' + this.tipo + '/datainizio/' + this.datainizio +'/datafine/' + this.datafine, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.items = response.data.message;
                            let apptable = this;

                            var prenotazione = new Prenotazione();
                            apptable.items.forEach(function(element, index) {

                                delete element.uteins; //per motivi di ricerca
                            
                                element.stato = prenotazione.getStatoByFlag(element.flagsta);
                                element.datainizio_ric = apptable.$options.filters.formatDate(element.datainizio);
                                element.datafine_ric = apptable.$options.filters.formatDate(element.datafine);
                                element.datains_ric = apptable.$options.filters.formatDateTime(element.datains);

                                if(element.id_socio == null || element.id_socio == 'null' || parseInt(element.id_socio) <= 0){
                                    element.socioVis = '';
                                }
                                else{
                                    element.socioVis = element.cognomesocio + " " + element.nomesocio + " - " + element.accountsocio;
                                }

                                if(apptable.tipo == 'E'){

                                    element.totacconto = Number.parseFloat((element.totalesaldo == 0 ? element.totalepagato : Math.min(element.totaleacconto, element.totalepagato))).toFixed(2) + "/" + Number.parseFloat(element.totaleacconto).toFixed(2);
                                    element.totacconto = (element.totacconto == '0.00/0.00' ? '' : element.totacconto);

                                    var auxdiff = element.totalepagato - (element.totalesaldo == 0 ? element.totalepagato : Math.min(element.totaleacconto, element.totalepagato));
                                    auxdiff = (auxdiff < 0 ? 0 : auxdiff);
                                    element.totsaldo = Number.parseFloat(auxdiff).toFixed(2) + "/" + Number.parseFloat(element.totalesaldo).toFixed(2); 
                                    element.totsaldo = (element.totsaldo == '0.00/0.00' ? '' : element.totsaldo);

                                }
                                else if(apptable.tipo == 'I'){
                                    //ATTENZIONE: spostato all'inizio del created

                                    //non visualizzo queste due colonne
                                    //delete apptable.fields.totacconto;
                                    //delete apptable.fields.totsaldo;

                                    //////////////////////////////////////////////

                                    //visualizzazione personalizzata da dashboard
                                    if(apptable.showflgpreimplistpers1){

                                        let datainizioAux = apptable.$options.filters.formatDate(element.datainizio);
                                        let datafineAux = apptable.$options.filters.formatDate(element.datafine);

                                        if(datainizioAux == datafineAux){
                                            element.dataVis = datainizioAux;
                                        }
                                        else{
                                            element.dataVis = datainizioAux + " - " + datafineAux;
                                        }
                                        
                                        element.oraVis = element.orainizio + " - " + element.orafine;
                                        if(element.accountsocio2 == null || element.accountsocio2 == 'null' || element.accountsocio2 == ''){
                                            element.socio2Vis = 'Nessuno';
                                        }
                                        else{
                                            element.socio2Vis = element.cognomesocio2 + " " + element.nomesocio2 + " - " + element.accountsocio2;
                                        }

                                        //per ora i pagamenti sugli impianti non vengono gestiti
                                        //ma viene gestita la registrazione diretta sulla prenotazione del presso e lo stato "Pagata"
                                        let saldoAux = Number.parseFloat(element.totalesaldo).toFixed(2);

                                        //element.totacconto = (element.totacconto == '0.00/0.00' ? '' : element.totacconto);

                                        element.importoVis = saldoAux;

                                    }

                                }

                                if (element.flagsta == 'A') {
                                    element._rowVariant = 'danger';
                                }
                            
                                //element.socioVis = element.cognomesocio + " " + element.nomesocio
                                //element.ruoloVis = socio.getRuoloByFlag(element.flgruolo);
                            });

                            apptable.items = apptable.items.filter(function (element) { 
                            
                                if(apptable.tipo == 'E'){
                                    return ctrlViscategoria(element.id_categoriaevento);
                                }
                                else if(apptable.tipo == 'I'){
                                    return ctrlViscategoria(element.id_categoriaimpianto);
                                }ctrlViscategoria
                            
                                return true;
                            });

                            this.showtable = true;

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

                ////////////////////////////////////////////////

                var token = localStorage.getItem('token');
                if (this.id != null && this.tipo == 'I') {
                                
                    this.axios.get(NAMESPACE + 'rest/impianti/' + this.id, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {

                                        this.flgsocio2 = res[0].flgsocio2;
                                        this.msgpreno = res[0].msgpreno;
                                        this.nominativo = res[0].nominativo;
                                        this.showtable2 = true;

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }

                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                this.showerror = true;
                                this.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            this.showerror = true;
                            this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });
                }
                else{
                    this.showtable2 = true;
                }





        },      
        insert() {
            if (this.tipo == 'I'){
                //se impianto, mostro la modal per scelta della data
                this.dateModal.errorData = '';
                this.dateModal.selDate = moment().format("YYYY-MM-DD");
                this.dateModal.id_socio = null;
                this.dateModal.nomesocio = '';
                this.dateModal.cognomesocio = '';
                this.dateModal.dateSocioVis = '';
                this.dateModal.accountsocio = '';
                this.dateModal.errorData = '';
                this.dateModal.items = [];
                this.delSocio2();
                this.dateModal.show = true;
            }
            else if (this.tipo == 'E'){
                this.$router.push('/app/dettaglioprenotazione/id_scheda/' + this.id + '/tipo/' + this.tipo);
            }            
        },
        details(item, index, button) {

            if (this.tipo == 'I'){
                this.$router.push('/app/dettaglioprenotazione/id/' + item.id + '/id_scheda/' + this.id + '/tipo/' + this.tipo);
            }
            else if (this.tipo == 'E'){
                this.$router.push('/app/dettaglioprenotazione/id/' + item.id + '/id_scheda/' + this.id + '/tipo/' + this.tipo);
            }           

        },
        paga(item, index, button) {

            this.pagaModal.id = item.id;
            this.pagaModal.nominativoimpianto = item.nominativoimpianto;
            this.pagaModal.dataVis = item.dataVis;
            this.pagaModal.oraVis = item.oraVis;
            this.pagaModal.socioVis = item.socioVis;            
            this.pagaModal.totalesaldo = item.totalesaldo;
            this.pagaModal.item = item;
            this.pagaModal.show = true;           

        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.show = true;
        },
        noteabbonamentoAmmonizione(){

            let noteAux = this.noteabbonamentoModal.note.toLowerCase().replace(/°/g, "").replace(/\n/g, " "); //regular expression

            //console.log("Replace: " + noteAux)

            let noteArray = noteAux.split(" ");

            let ctrl = false;
            
            for(var i = noteArray.length - 1; i > 0; i--){
                if(noteArray[i].indexOf("ammonizion") >= 0 && Number.isInteger(parseInt(noteArray[i-1]))){
                    let intAux = parseInt(noteArray[i-1]);
                    ctrl = true;
                    this.noteabbonamentoModal.note += "\n" + (++intAux) + "° ammonizione";
                    break;
                }
            }

            if(!ctrl){
                this.noteabbonamentoModal.note += (noteAux.trim() == "" ? "" : "\n") + "1° ammonizione";
            }

        },
        noteabbonamentoItem(id, note){
            
            var element2 = {};
            element2.id = id;
            element2.note = note;

            var json = JSON.stringify(element2);
            
            var token = localStorage.getItem('token');
            this.axios.post(NAMESPACE + 'rest/abbonamentonote', json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {
                            if (response.data.token != null) localStorage.setItem('token', response.data.token);
                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.noteabbonamentoModal.show = false;
                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }
                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {
                        this.noteabbonamentoModal.show = false;
                        alert("Errore: " + e.message);
                    }
                })
                .catch(e => {

                    this.noteabbonamentoModal.show = false;
                    alert("Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                });

        },
        pagaItem(element, totalesaldo){

            //metto la prenotazione con stato Pagato
            //element.flagsta = "P"; //non serve più creato servizio apposta

            //clono l'oggetto
            var element2 = Object.assign({}, element);
            element2.totalesaldo = totalesaldo;

            var json = JSON.stringify(element2);
            
            var token = localStorage.getItem('token');
            this.axios.post(NAMESPACE + 'rest/prenotazionepagata', json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    var pr = new Prenotazione();
                                    this.prenotazione = res[0];
                                    //forse può essere fatta diversamente e meglio
                                    for (var i = 0; i < this.items.length; i++) {
                                        if (this.items[i].id == this.prenotazione.id) {
                                            this.items[i].flagsta = this.prenotazione.flagsta;
                                            this.items[i].importosaldo = this.prenotazione.importosaldo;
                                            this.items[i].totalesaldo = this.prenotazione.totalesaldo;

                                            //per ora i pagamenti sugli impianti non vengono gestiti
                                            //ma viene gestita la registrazione diretta sulla prenotazione del presso e lo stato "Pagata"
                                            element.importoVis = Number.parseFloat(element.totalesaldo).toFixed(2);

                                            this.items[i].stato = pr.getStatoByFlag(this.prenotazione.flagsta);
                                            break;
                                        }
                                    }                                    
                                    this.pagaModal.show = false;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {

                        this.pagaModal.show = false;
                        //this.showerror = true;
                        //this.error = "Errore: " + e.message;
                        alert("Errore: " + e.message);
                    }

                })
                .catch(e => {

                    this.pagaModal.show = false;
                    //this.showerror = true;
                    //this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    alert("Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                });

        },
        delItem() {

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/prenotazioni/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < this.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {

                        this.deleteModal.show = false;
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {

                    this.deleteModal.show = false;
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getImportoStyle(importo){
            if(typeof importo != 'undefined' && importo.indexOf("/") >= 0){
                var parz = Number.parseFloat(importo.split('/')[0]);
                var tot = Number.parseFloat(importo.split('/')[1]);
                if(parz == tot){
                    return "font-weight:bold;color:green;";
                }
                if(parz < tot){
                    return "font-weight:bold;color:red;";
                }
                else{
                    return "font-weight:bold;color:blue;";
                }
            }
            return "";
        },
        getImportoImpiantiStyle(element){
            //console.log("Element: " + JSON.stringify(element))
            if(typeof element.importoVis != 'undefined'){
                var tot = Number.parseFloat(element.importoVis);
                if(tot == 0 && element.flagsta != 'A'){
                    return "font-weight:bold;color:blue;";
                }
                if(tot > 0 && element.flagsta != 'P' && element.flagsta != 'A'){
                    return "font-weight:bold;color:red;";
                }
                else if(tot > 0 && element.flagsta == 'P'){
                    return "font-weight:bold;color:green;";
                }
            }
            return "";
        },
    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY');
        },
        formatDateTime: function (value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
        },
        formatNote: function(value) {
            var numChar = 150;
            if (!value) return '';
            return value.substr(0, numChar) + (value.length <= numChar ? '' : ' ...');
        }
    },
    created: function () {


        
        if(!ctrlVismenu("R")){
            this.$router.replace('/accessdenied');
            return;
        }

        //per motivi di prestazioni mettiamo se null sempre delle date di default negli impianti o accesso da dashboard
        if(this.$route.params.datainizio == null && this.$route.params.datafine == null && (this.tipo == 'I' || this.id == null)){

            let today = moment(String(new Date())).format('YYYY-MM-DD');
            this.datainizio = today;
            let new_date = moment(today, "YYYY-MM-DD").add(30, 'days').format("YYYY-MM-DD");            
            this.datafine = new_date;

        }

        this.loadParametriData();

    }
}
</script>
